export type StatusCodeTagColor = 'success' | 'warning' | 'error';

// The `0` code (a connection-level failure with no response) falls into the
// error branch along with 4xx and 5xx.
export function statusCodeTagColor(statusCode: number): StatusCodeTagColor {
  if (statusCode >= 200 && statusCode < 300) return 'success';
  if (statusCode >= 300 && statusCode < 400) return 'warning';
  return 'error';
}
